<template>
  <div class="fixed_page"  id="blurry">
    <div class="get-started">
      <div class="fixed_page">
        <div   v-if="!isEditMode()" class="home_stats_box profile_stats_box">
          <div class="profile_edit_icon_bg"
               v-if="!isEditMode()"
               @click.prevent="toEdit()"
               style="cursor: pointer" >
            <img class="profile_edit_icon" src="/static/images/home/icon-edit.svg" />
          </div>
          <div  v-if="!isEditMode()" class="profile_row flex-row">
            <img  :src="userDetails.avatar"  class="avatar_profile"/>
            <div class="profile_user_info">
              <h4>{{ getDisplayUsername }}</h4></div>
          </div>


          <div class="info_horizontal_line"></div>

          <div v-if="hasFb()">
            <facebook-login :enteredUsername="userDetails.username"
                            :errorsInFb="errorInFb"
                            @errorsUpdated="methodForEvent($event)"
                            :type="fbActionType" >

            </facebook-login>
            <span class="custom_fb_error_msg"
                  v-if="errorInFb">{{ getTranslations.home_store_this_fb }}
          </span>
          </div>

        </div>
        <profile-stats v-if="!isEditMode()"></profile-stats>
        <div v-if="isEditMode()">
          <div class="profile_edit_box">
            <img  :src="userDetails.avatar" />
            <h1>{{ getDisplayUsername }}</h1>
          </div>
          <edit-avatar ></edit-avatar>
        </div>
        <div v-if="!isEditMode()"  class="circle_background">
          <profile-performance></profile-performance>
          <achievements-profile :has-filters="false"></achievements-profile>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import FacebookLogin from '@/components/visitor/FacebookLogin';
import ProfileStats from './ProfileStats';
import EditAvatar from './EditAvatar';
import DefaultContentProfile from './DefaultContentProfile';
import ProfilePerformance from './ProfilePerformance';
import AchievementsProfile from './AchievementsProfile';

export default {
  name: 'profile',
  data() {
    return {
      fbActionType: 'ConnectProf',
      errorInFb: false,
    };
  },
  created() {
  },
  components: {
    AchievementsProfile,
    ProfilePerformance,
    DefaultContentProfile,
    ProfileStats,
    EditAvatar,
    FacebookLogin,
  },
  methods: {
    ...mapActions('profile', [
      'storePerformance',
    ]),
    getFbMessage() {
      return this.getTranslations.visitor_sign_up_3_fb_username_first;
    },
    methodForEvent(event) {
      this.errorInFb = event;
    },
    toEdit() {
      this.$router.push('/home/profile/edit');
    },
    isEditMode() {
      return this.$route.path === '/home/profile/edit';
    },
    hasFb() {
      return this.$route.path === '/home/profile'
        && !this.userDetails.facebookId
        && this.facebookFunctionality;
    },
  },
  computed: {
    getDisplayUsername() {
      return this.userDetails.username;
    },
    ...mapState('common', [
      'userDetails',
      'userAvatar',
      'connectionPoints',
      'facebookFunctionality',
    ]),
    ...mapState('profile', [
      'performanceInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/Profile.vue